import React, { useState } from "react";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(
      "https://iegfuewhpam5esqz4oofbqsfmu0ixktl.lambda-url.eu-west-1.on.aws/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, message }),
      },
    )
      .then(() => {
        setSuccessMessage("Kiitos viestistäsi! Vastaamme mahdollisimman pian.");
        clearState();
      })
      .catch((error) => {
        console.error(error);
        setSuccessMessage("Viestin lähetyksessä tapahtui virhe");
      });
  };

  const openPopup = (e) => {
    e.preventDefault();
    const newWindow = window.open(
      "",
      "",
      "width=600,height=800,scrollbars=yes",
    );
    newWindow.document.write(`
      <html>
        <head>
          <title>Rekisteri- ja tietosuojaseloste</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; line-height: 1.6; }
            h1 { font-size: 1.5em; margin-bottom: 0.5em; }
            p, ul { margin-bottom: 1em; }
          </style>
        </head>
        <body>
          <h1>Rekisteri- ja tietosuojaseloste</h1>
          <p>Tämä on Pienremppaamo Oy:n EU:n yleisen tietosuoja-asetuksen (GDPR) mukainen rekisteri- ja tietosuojaseloste. Laadittu 17.9.2024.</p>
          <h2>1. Rekisterinpitäjä</h2>
          <p>Pienremppaamo Oy (3471328-7)<br>
          Myöhemmin tässä selosteessa Yritys.<br>
          Krankantie 8, 00400 Helsinki.</p>

          <h2>2. Rekisteristä vastaava yhteyshenkilö</h2>
          <p>Annika Heikinheimo<br>
          info@pienremppaamo.fi<br>
          040 418 5662</p>

          <h2>3. Rekisterin nimi</h2>
          <p>Yrityksen asiakas- ja markkinointirekisteri</p>

          <h2>4. Oikeusperuste ja henkilötietojen käsittelyn tarkoitus</h2>
          <p>Rekisteriin tallennettuja henkilötietoja käsitellään henkilötietolain 8 §:n edellytysten mukaisesti Yrityksen asiakassuhteiden hoitamiseen.
          Rekisteri on Yrityksen omaan käyttöön tarkoitettu rekisteri. Henkilötietojen käsittelyn perusteena on asiakkuussuhteet tai muu asiallinen yhteys, asiakkaan antama lupa tai toimeksianto. Rekisterin tietoja käytetään asiakkuuksien hoitamiseen ja kehittämiseen, maksunvalvontaan sekä markkinointiviestintään.</p>

          <h2>5. Rekisterin tietosisältö</h2>
          <p>Rekisterissä käsitellään Yrityksen asiakkaiden henkilö- ja yhteystietoja sekä muita asiakkuuteen liittyviä tarpeellisia tietoja. Asiakassuhteen hoitamiseen liittyviä tietoja on mm:</p>
          <ul>
            <li>Yrityksen nimi ja Y-tunnus sekä yhteyshenkilön nimi</li>
            <li>Sähköpostiosoite, puhelinnumero, www-sivujen osoite</li>
            <li>Asiakkuuden sopimuksiin liittyvät tiedot kuten tuote- ja hintatiedot, palveluiden kuvaukset, asiakaspalautteet, toimitus- ja laskutustiedot sekä yhteydenotot.</li>
            <li>Asiakassuhteen viestintähistoria (mm. sähköpostiviestit ja puhelutiedot) ja reklamaatiot.</li>
          </ul>

          <h2>6. Säännönmukaiset tietolähteet</h2>
          <p>Rekisteriin tallennettavat tiedot saadaan asiakkaalta mm. www-lomakkeilla lähetetyistä viesteistä, sähköpostitse, puhelimitse, sosiaalisen median palvelujen kautta, sopimuksista, asiakastapaamisista ja muista tilanteista, joissa asiakas luovuttaa tietojaan.
          Yritysten ja muiden organisaatioiden yhteyshenkilöiden tietoja voidaan kerätä myös julkisista lähteistä kuten verkkosivuilta, hakemistopalveluista ja muilta yrityksiltä.</p>

          <h2>7. Tietojen säännönmukaiset luovutukset ja tietojen siirto EU:n tai ETA:n ulkopuolelle</h2>
          <p>Tietoja ei luovuteta säännönmukaisesti muille tahoille. Tietoja voidaan julkaista siltä osin kuin niin on sovittu asiakkaan kanssa.
          Tietoja voidaan siirtää rekisterinpitäjän toimesta myös EU:n tai ETA:n ulkopuolelle. Tietoja ei siirretä Yhdysvaltoihin ilman rekisteröityjen nimenomaista suostumusta.</p>

          <h2>8. Rekisterin suojauksen periaatteet</h2>
          <p>Rekisterin käsittelyssä noudatetaan huolellisuutta ja tietojärjestelmien avulla käsiteltävät tiedot suojataan asianmukaisesti. Kun rekisteritietoja säilytetään Internet-palvelimilla, niiden laitteiston fyysisestä ja digitaalisesta tietoturvasta huolehditaan asiaankuuluvasti. Rekisterinpitäjä huolehtii siitä, että tallennettuja tietoja sekä palvelimien käyttöoikeuksia ja muita henkilötietojen turvallisuuden kannalta kriittisiä tietoja käsitellään luottamuksellisesti ja vain niiden työntekijöiden toimesta, joiden työnkuvaan se kuuluu.</p>

          <h2>9. Tarkastusoikeus ja oikeus vaatia tiedon korjaamista</h2>
          <p>Jokaisella rekisterissä olevalla henkilöllä on oikeus tarkistaa rekisteriin tallennetut tietonsa ja vaatia mahdollisen virheellisen tiedon korjaamista tai puutteellisen tiedon täydentämistä. Mikäli henkilö haluaa tarkistaa hänestä tallennetut tiedot tai vaatia niihin oikaisua, pyyntö tulee lähettää kirjallisesti rekisterinpitäjälle. Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan henkilöllisyytensä. Rekisterinpitäjä vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa (pääsääntöisesti kuukauden kuluessa).</p>

          <h2>10. Muut henkilötietojen käsittelyyn liittyvät oikeudet</h2>
          <p>Rekisterissä olevalla henkilöllä on oikeus pyytää häntä koskevien henkilötietojen poistamiseen rekisteristä ("oikeus tulla unohdetuksi"). Niin ikään rekisteröidyillä on muut EU:n yleisen tietosuoja-asetuksen mukaiset oikeudet kuten henkilötietojen käsittelyn rajoittaminen tietyissä tilanteissa. Pyynnöt tulee lähettää kirjallisesti rekisterinpitäjälle. Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan henkilöllisyytensä. Rekisterinpitäjä vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa (pääsääntöisesti kuukauden kuluessa).</p>
        </body>
      </html>
    `);
    newWindow.document.close();
  };

  return (
    <section id="contact" className="container">
      <div className="col-md-8">
        <h2>Ota yhteyttä</h2>
        <p>
          Olipa kyseessä pieni pintaremontti tai suunnittelupulma, me hoidamme
          sen ammattitaidolla ja suurella sydämellä.
        </p>
        <p>Meille ei ole olemassa liian pientä pintaremonttia.</p>
        <p>
          Ota rohkeasti yhteyttä ja suunnitellaan yhdessä kotiisi sopiva
          ratkaisu.
        </p>
        <form name="sentMessage" validate onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="form-control"
                  placeholder="Nimi"
                  required
                  onChange={handleChange}
                  value={name}
                />
                <p className="help-block text-danger"></p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control"
                  placeholder="Sähköposti"
                  required
                  onChange={handleChange}
                  value={email}
                />
                <p className="help-block text-danger"></p>
              </div>
            </div>
          </div>
          <div className="form-group">
            <textarea
              name="message"
              id="message"
              className="form-control"
              rows="4"
              placeholder="Viesti"
              required
              onChange={handleChange}
              value={message}
            ></textarea>
            <p className="help-block text-danger"></p>
          </div>
          <div id="success"></div>
          {successMessage && <strong><h3 className="success-message">{successMessage}</h3></strong>}
          <button type="submit" className="btn btn-custom btn-lg">
            Lähetä viesti
          </button>
        </form>
        <button
          type="button"
          onClick={openPopup}
          style={{
            color: "#D6536D",
            textDecoration: "underline",
            fontSize: "15px",
            background: "none",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
        >
          tietosuojaseloste
        </button>
      </div>

      <aside className="col-md-3 col-md-offset-1 contact-info">
        <h3>Yhteystiedot</h3>
        <p>
          <i className="fa fa-envelope-o"></i>{" "}
          <a
            href={"mailto:" + (props.data ? props.data.email : "loading")}
            style={{ color: "#D6536D" }}
          >
            {props.data ? props.data.email : "loading"}
          </a>
        </p>
        <p>
          <i className="fa fa-phone"></i>{" "}
          <a
            href={"tel:" + (props.data ? props.data.phone : "loading")}
            style={{ color: "#D6536D" }}
          >
            {props.data ? props.data.phone : "loading"}
          </a>
        </p>
        <p>
          <i className="fa fa-instagram"></i>{" "}
          <a
            href={props.data ? props.data.instagram : "loading"}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#D6536D" }}
          >
            Instagram
          </a>
        </p>
        <p>
          <i className="fa fa-facebook"></i>{" "}
          <a
            href={props.data ? props.data.facebook : "loading"}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#D6536D" }}
          >
            Facebook
          </a>
        </p>
        <p>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
            style={{ marginRight: "8px", verticalAlign: "middle" }}
          >
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-.04-.1z"/>
          </svg>
          <a
            href={props.data ? props.data.tiktok : "loading"}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#D6536D" }}
          >
            TikTok
          </a>
        </p>
        <p style={{ color: "#D6536D" }}>Y-tunnus: 3471328-7</p>
      </aside>
    </section>
  );
};
